/* tslint:disable */

/**
 */
export class TypeAny {
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/type-any.ts